/* A theme generated by our createTheme function looks like:
{
  color: {
    text: '#000',
    background: '#fff',
    primary: '#07c',
    modes: {
      dark: {
        text: '#fff',
        background: '#000',
        primary: '#0cf',
      }
    }
  },
  // the rest of the tokens
}
For a given mode (ex: dark), this function will return an alternate theme with different colors:
{
  color: {
    text: '#fff',
    background: '#000',
    primary: '#0cf',
  },
  // the rest of the tokens
} */
export default function applyColorMode(theme: any, mode: string) {
  const { color, ...rest } = theme
  const { modes, ...normal } = color
  // TODO: use deepmerge ?
  return { color: { ...normal, ...modes[mode] }, ...rest }
}
